import { render, staticRenderFns } from "./InstalmentAmount.vue?vue&type=template&id=624b80e2&"
import script from "./InstalmentAmount.vue?vue&type=script&lang=js&"
export * from "./InstalmentAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports